import gql from 'graphql-tag'

import { IToursWhereInput } from './common'

// Good practice numero 1 in programare - keep local code in local scope. Move it to the parent scope only when it's shared
export const ToursMapItemFragment = gql`
	fragment ToursMapItemFragment on ToursMapItem {
		id
        lat
        lng
        categoryId
        slug
        citySlug
        regionSlug
        countrySlug
	}
`

export const ToursMapQuery = gql`
	query toursMap($where: TourWhereInput!) {
		toursMap(where: $where) {
			...ToursMapItemFragment
		}
	}
	${ToursMapItemFragment}
`

export interface IToursMapQueryVariables {
    where: IToursWhereInput
}

export interface IToursMapQueryData {
    toursMap: IToursMapItem[]
}

export interface IToursMapItem {
    id: number
    lat: number
    lng: number
    categoryId: number
    slug: string
    citySlug: string
    regionSlug: string
    countrySlug: string
}